const n = {
  name: "Monitoring",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19 2C20.6523 2 22 3.34772 22 5V19C22 20.6523 20.6523 22 19 22H5C3.34772 22 2 20.6523 2 19V5C2 3.34772 3.34772 2 5 2H19ZM20 5C20 4.45228 19.5477 4 19 4H5C4.45228 4 4 4.45228 4 5V11H7.67703L9.5 15.5574L13.323 6H15.677L17.677 11H20V5ZM20 13H16.323L14.5 8.44258L10.677 18H8.32297L6.32297 13H4V19C4 19.5477 4.45228 20 5 20H19C19.5477 20 20 19.5477 20 19V13Z" fill="currentColor"/>
</svg>
  `
};
export {
  n as Monitoring
};
